import "../../global.css";
import "./onboarding.css";
import { useEffect, useState } from "react";
import { publicRequest, urlAdminMooda, urlMooda } from "../../requestMethods";
import { normalizeSlug } from "../../util/slug";
import { defaultAccessControl } from "../../util/defaultAccessControl";
import { formatTimeYYYYMMDD } from "../../util/helper";
import Swal from "sweetalert2";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import Container from "@mui/material/Container";
import { useLocation } from "react-router-dom";

const Company = () => {
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const [inputs, setInputs] = useState({});
  const [plano, setPlano] = useState("");
  const [criado, setCriado] = useState(false);
  const [showDashboard, setShowDashboard] = useState(true);
  const [showPrice, setShowPrice] = useState(false);
  const [showCashback, setShowCashback] = useState(false);
  const [showFrete, setShowFrete] = useState(true);
  const [razao_social, setRzao_social] = useState("");
  const [socio, setSocio] = useState("");
  const [end_empresa, setEnd_empresa] = useState("");
  const [end_num_empresa, setEnd_num_empresa] = useState("");
  const [end_comp_empresa, setEnd_comp_empresa] = useState("");
  const [end_bairro, setEnd_bairro] = useState("");
  const [end_cep, setEnd_cep] = useState("");
  const [end_ddd, setEnd_ddd] = useState("");
  const [end_tel, setEnd_tel] = useState("");
  const [end_estado, setEnd_estado] = useState("");
  const [end_cidade, setEnd_cidade] = useState("");
  const [cnpj_cpf, setCnpj_cpf] = useState("");
  const [cep, setCep] = useState("");
  const [street, setStreet] = useState("");
  const [complement, setComplement] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [states, setStates] = useState([]);
  const [dataNiver, setDateNiver] = useState("");
  const [tipoTelPay, setTipoTelPay] = useState("");
  const [tipoTelEmp, setTipoTelEmp] = useState("");
  const [layout, setLayout] = useState("");
  const [approval, setApproval] = useState(false);
  const [mainActivityId, setMainActivityId] = useState("4781400");

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if (id !== "new") {
      getCompany();
    }
  }, [id]);

  const handleChangePlano = (e) => setPlano(e.target.value);
  const handleChangeTelPay = (e) => setTipoTelPay(e.target.value);
  const handleChangeTelEmp = (e) => setTipoTelEmp(e.target.value);
  const handleChangeDash = (e) => setShowDashboard(e.target.value === "true");
  const handleChangePrice = (e) => setShowPrice(e.target.value === "true");
  const handleChangeCash = (e) => setShowCashback(e.target.value === "true");
  const handleChangeFrete = (e) => setShowFrete(e.target.value === "true");
  const handleChangeLayout = (e) => setLayout(e.target.value);
  const handleChangeStart = (e) => setDateNiver(e.target.value);

  const handleChange = (e) => {
    setInputs((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // A Url da company vira a rota publica: sempre minuscula e sem acento.
  const handleChangeSlug = (e) => {
    const slug = normalizeSlug(e.target.value);
    setInputs((prev) => ({ ...prev, slug }));
  };

  const handleChangeCEP = (e) => {
    if (e.target.value.length === 8) getCep(e.target.value);
  };

  const validaSlug = async (slug) => {
    const res = await publicRequest.get(`/company/${slug}`);
    return Object.keys(res.data).length === 0;
  };

  const getCNPJ = async (cnpj) => {
    const res = await publicRequest.get(`1/customers/cnpj/${cnpj}`);
    if (Object.keys(res.data).length > 0) {
      setRzao_social(res.data.razao_social);
      setSocio(res.data.socio);
      setEnd_empresa(res.data.end_empresa);
      setEnd_num_empresa(res.data.end_num_empresa);
      setEnd_comp_empresa(res.data.end_comp_empresa);
      setEnd_bairro(res.data.end_bairro);
      setEnd_cep(res.data.end_cep);
      setEnd_ddd(res.data.end_ddd);
      setEnd_tel(res.data.end_tel);
      setEnd_estado(res.data.end_estado);
      setEnd_cidade(res.data.end_cidade);
    }
    setCnpj_cpf(cnpj);
  };

  const getCep = async (cep) => {
    const res = await publicRequest.get(`1/customers/cep/${cep}`);
    setCep(cep);
    if (Object.keys(res.data).length > 0) {
      setStreet(res.data.logradouro.toUpperCase());
      setDistrict(res.data.bairro.toUpperCase());
      setCity(res.data.localidade.toUpperCase());
      setState(res.data.uf.toUpperCase());
    }
  };

  const handleChangeCNPJ = (e) => {
    const val = e.target.value;
    setCnpj_cpf(val);
    if (val.length === 14) getCNPJ(val.trim());
  };

  const getStates = async () => {
    const res = await publicRequest.get(`1/customers/state`);
    setStates(res.data);
  };

  // 🔹 Função principal para popular os campos com os dados da empresa
  const getCompany = async () => {
    try {
      const res = await publicRequest.get(`/company/find/${id}`);
      const data = res.data;
      console.log(">>>>>", res.data);
      setRzao_social(data.rzSocial || data.name || "");
      setCnpj_cpf(data.cnpj || "");
      setPlano(data?.planContract?.plan || "");
      setShowDashboard(data?.planContract?.showDashboard ?? true);
      setShowPrice(data?.planContract?.showPrice ?? false);
      setShowCashback(data?.planContract?.showCashback ?? false);
      setShowFrete(data?.planContract?.delivery ?? true);
      setLayout(data?.configUI?.layout || "default");
      setApproval(data?.customerApprovel?.approval ?? false);
      setMainActivityId(
        (data?.customerApprovel?.mainActivityId || [4781400]).join(",")
      );

      setEnd_empresa(data?.address?.street || "");
      setEnd_num_empresa(data?.address?.numAddress || "");
      setEnd_comp_empresa(data?.address?.complement || "");
      setEnd_bairro(data?.address?.district || "");
      setEnd_cep(data?.address?.cep || "");
      setEnd_estado(data?.address?.state || "");
      setEnd_cidade(data?.address?.city || "");

      if (data?.accountPay?.accountPay?.company?.phones?.length) {
        const phone = data.accountPay.accountPay.company.phones[0];
        setEnd_ddd(phone.area || "");
        setEnd_tel(phone.number || "");
        setTipoTelEmp(phone.type || "");
      }
      console.log(">>>>", data);
      setInputs((prev) => ({
        ...prev,
        slug: data.slug || "",
        hootspy: data.hootspy || "",
      }));
      if (data?.accountPay?.accountPay?.person) {
        const person = data.accountPay.accountPay.person;
        setSocio(person.name || "");
        setDateNiver(person.birth_date || "");
        setInputs((prev) => ({
          ...prev,
          emailPay: data?.accountPay?.accountPay?.email || "",
          motherPay: person.mother_name || "",
          owner_cpfPay: person.tax_id || "",
          numberPay: person.address?.number || "",
          complementPay: person.address?.complement || "",
          contactDDDPay: person.phones?.[0]?.area || "",
          contactPay: person.phones?.[0]?.number || "",
        }));
        setCep(person.address?.postal_code || "");
        setStreet(person.address?.street || "");
        setDistrict(person.address?.locality || "");
        setCity(person.address?.city || "");
        setState(person.address?.region_code || "");
        setTipoTelPay(person.phones?.[0]?.type || "");
      }
    } catch (error) {
      console.error("Erro ao carregar empresa:", error);
    }
  };

  const click = async () => {
    try {
      let obj = {
        name: razao_social,
        cnpj: cnpj_cpf,
        contact: inputs.contactDDDPay + inputs.contactPay,
        email: inputs.emailPay,
        address: {
          street: end_empresa,
          number: end_num_empresa,
          complement: end_comp_empresa,
          locality: end_bairro,
          city: end_cidade,
          region_code: end_estado,
          country: "BRA",
          postal_code: end_cep,
        },
        CEP: cep,
        city: city,
        state: state,
        rzSocial: razao_social,
        slug: normalizeSlug(inputs.slug),
        hootspy: inputs.hootspy,
        planContract: {
          plan: plano,
          showDashboard: showDashboard,
          delivery: showFrete,
          showPrice: showPrice,
          showCashback: showCashback,
        },
        configRules: { minProducts: 10 },
        customerApprovel: {
          approval: approval,
          mainActivityId: mainActivityId
            .split(",")
            .map((v) => Number(v.trim()))
            .filter((v) => !isNaN(v) && v > 0),
        },
        enable: true,
        accessControl: defaultAccessControl(),
        accountPay: {
          type: "SELLER",
          person: {
            address: {
              street: street,
              number: inputs.numberPay,
              complement: inputs.complementPay,
              locality: district,
              city: city,
              region_code: state,
              country: "BRA",
              postal_code: cep,
            },
            name: socio,
            birth_date: formatTimeYYYYMMDD(dataNiver),
            mother_name: inputs.motherPay,
            tax_id: inputs.owner_cpfPay,
            phones: [
              {
                country: 55,
                area: inputs.contactDDDPay,
                number: inputs.contactPay,
                type: tipoTelPay,
              },
            ],
          },
          tos_acceptance: {
            user_ip: "",
            date: new Date(),
          },
          business_category: "CLOTHING_AND_ACCESSORIES",
          email: inputs.emailPay,
          company: {
            name: razao_social,
            tax_id: cnpj_cpf,
            address: {
              street: end_empresa,
              number: end_num_empresa,
              complement: end_comp_empresa,
              locality: end_bairro,
              city: end_cidade,
              region_code: end_estado,
              country: "BRA",
              postal_code: end_cep,
            },
            phones: [
              {
                country: 55,
                area: end_ddd,
                number: end_tel,
                type: tipoTelEmp,
              },
            ],
          },
        },
      };

      // 🔹 Se for um novo cliente
      if (id === "new") {
        if (!(await validaSlug(normalizeSlug(inputs.slug)))) {
          Swal.fire("Atenção!", "URL existente.", "warning");
          return;
        }

        const res = await publicRequest.post(`/company/`, obj);
        if (res?.data?.companyId) {
          Swal.fire("Sucesso!", "Cliente criado com sucesso.", "success");
          setCriado(true);
        } else {
          Swal.fire("Erro!", "Falha ao criar cliente.", "error");
        }
      }
      // 🔹 Se for update
      else {
        const res = await publicRequest.put(`${id}/company`, obj);

        if (res.status === 200) {
          Swal.fire("Sucesso!", "Dados atualizados com sucesso!", "success");
        } else {
          Swal.fire("Erro!", "Falha ao atualizar os dados.", "error");
        }
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Erro!", "Ocorreu um problema ao salvar.", "error");
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <div className="div_custom_Form">
        {id !== "new" ? (
          <span className="div_custom_UpdateTitle">Editar Cliente</span>
        ) : (
          <span className="div_custom_UpdateTitle">Novo Cliente</span>
        )}
        <div className="div_custom_UpdateLeft">
          {/* CNPJ */}
          <div className="div_custom_UpdateItem">
            <label>CNPJ</label>
            <input
              type="text"
              name="cnpj"
              className="div_custom_UpdateInput"
              onChange={handleChangeCNPJ}
              maxLength="14"
              value={cnpj_cpf || ""}
              placeholder="12345678901234"
            />
          </div>

          {/* Nome cliente */}
          <div className="div_custom_UpdateItem">
            <label>Nome cliente</label>
            <input
              type="text"
              name="name"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={razao_social || ""}
            />
          </div>

          {/* URL */}
          <div className="div_custom_UpdateItem">
            <label>Url</label>
            <input
              type="text"
              name="slug"
              className="div_custom_UpdateInput"
              onChange={handleChangeSlug}
              value={inputs.slug || ""}
              placeholder="nomeurl"
            />
          </div>
          <div className="div_custom_UpdateItem">
            <label>Hootspy</label>
            <input
              type="text"
              name="hootspy"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={inputs.hootspy || ""}
              placeholder="codigo"
            />
          </div>
          {/* Plano */}
          <div className="div_custom_UpdateItem">
            <label>Plano</label>
            <select
              className="div_custom_Select"
              onChange={handleChangePlano}
              value={plano}
            >
              <option value=""></option>
              <option value="Bronze">Bronze</option>
              <option value="Prata">Prata</option>
              <option value="Ouro">Ouro</option>
              <option value="Diamante">Diamante</option>
            </select>
          </div>

          {/* Tipo Layout */}
          <div className="div_custom_UpdateItem">
            <label>Tipo Layout?</label>
            <select
              className="div_custom_Select"
              onChange={handleChangeLayout}
              value={layout}
            >
              <option value="default">Atacado</option>
              <option value="highligh_category">Highligh + 1 Categoria</option>
              <option value="category">1 Categoria</option>
              <option value="multi_category">2 Categoria</option>
            </select>
          </div>

          {/* Exibe dashboard/preço/frete/cashback */}
          <div className="div_custom_UpdateItem">
            <label>Exibe Dashboard?</label>
            <select
              className="div_custom_Select"
              onChange={handleChangeDash}
              value={showDashboard}
            >
              <option value=""></option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

          <div className="div_custom_UpdateItem">
            <label>Exibe Preço?</label>
            <select
              className="div_custom_Select"
              onChange={handleChangePrice}
              value={showPrice}
            >
              <option value=""></option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

          <div className="div_custom_UpdateItem">
            <label>Exibe Frete?</label>
            <select
              className="div_custom_Select"
              onChange={handleChangeFrete}
              value={showFrete}
            >
              <option value=""></option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

          <div className="div_custom_UpdateItem">
            <label>Exibe Cashback?</label>
            <select
              className="div_custom_Select"
              onChange={handleChangeCash}
              value={showCashback}
            >
              <option value=""></option>
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

          {/* Aprovação de cliente */}
          <div className="div_custom_UpdateItem">
            <label>Aprovação de cliente?</label>
            <select
              className="div_custom_Select"
              value={approval}
              onChange={(e) => setApproval(e.target.value === "true")}
            >
              <option value="true">Sim</option>
              <option value="false">Não</option>
            </select>
          </div>

          <div className="div_custom_UpdateItem">
            <label>CNAE(s) permitidos</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={mainActivityId}
              onChange={(e) => setMainActivityId(e.target.value)}
              placeholder="4781400,4782201"
            />
          </div>

          {/* Dados do Proprietário */}
          <div className="div_custom_UpdateItem full-width">
            <span className="subTitle">Dados do Proprietário</span>
          </div>

          <div className="div_custom_UpdateItem">
            <label>Nome do Proprietário</label>
            <input
              type="text"
              name="namePay"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={socio || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Email PagBank</label>
            <input
              type="email"
              name="emailPay"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={inputs.emailPay || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Data Nascimento</label>
            <input
              type="date"
              id="startDate"
              onChange={handleChangeStart}
              value={dataNiver || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Nome da mãe</label>
            <input
              type="text"
              name="motherPay"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={inputs.motherPay || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>CPF Proprietário</label>
            <input
              type="text"
              name="owner_cpfPay"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              maxLength="11"
              value={inputs.owner_cpfPay || ""}
            />
          </div>

          {/* Endereço Proprietário */}
          <div className="div_custom_UpdateItem">
            <label>CEP</label>
            <input
              type="text"
              name="cepPay"
              onChange={handleChangeCEP}
              className="div_custom_UpdateInput"
              maxLength="8"
              value={cep || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Endereço</label>
            <input
              type="text"
              name="street"
              onChange={handleChange}
              className="div_custom_UpdateInput"
              value={street || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Número</label>
            <input
              type="text"
              name="numberPay"
              onChange={handleChange}
              className="div_custom_UpdateInput"
              value={inputs.numberPay || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Complemento</label>
            <input
              type="text"
              name="complementPay"
              onChange={handleChange}
              className="div_custom_UpdateInput"
              value={inputs.complementPay || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Estado</label>
            <select
              className="div_custom_Select"
              value={state || ""}
              onChange={(e) => setState(e.target.value)}
            >
              <option value=""></option>
              {states.map((item) => (
                <option key={item.stateId} value={item.state}>
                  {item.state}
                </option>
              ))}
            </select>
          </div>

          <div className="div_custom_UpdateItem">
            <label>DDD</label>
            <input
              type="text"
              name="contactDDDPay"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={inputs.contactDDDPay || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Telefone</label>
            <input
              type="text"
              name="contactPay"
              className="div_custom_UpdateInput"
              onChange={handleChange}
              value={inputs.contactPay || ""}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Tipo Telefone</label>
            <select
              className="div_custom_Select"
              onChange={handleChangeTelPay}
              value={tipoTelPay}
            >
              <option value=""></option>
              <option value="MOBILE">Celular</option>
              <option value="BUSINESS">Empresa</option>
              <option value="HOME">Casa</option>
            </select>
          </div>

          {/* Dados da Empresa */}
          <div className="div_custom_UpdateItem full-width">
            <span className="subTitle">Dados da Empresa</span>
          </div>

          <div className="div_custom_UpdateItem">
            <label>CEP</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={end_cep || ""}
              onChange={(e) => setEnd_cep(e.target.value)}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Endereço</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={end_empresa || ""}
              onChange={(e) => setEnd_empresa(e.target.value)}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Número</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={end_num_empresa || ""}
              onChange={(e) => setEnd_num_empresa(e.target.value)}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Complemento</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={end_comp_empresa || ""}
              onChange={(e) => setEnd_comp_empresa(e.target.value)}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Estado</label>
            <select
              className="div_custom_Select"
              value={end_estado || ""}
              onChange={(e) => setEnd_estado(e.target.value)}
            >
              <option value=""></option>
              {states.map((item) => (
                <option key={item.stateId} value={item.state}>
                  {item.state}
                </option>
              ))}
            </select>
          </div>

          <div className="div_custom_UpdateItem">
            <label>DDD</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={end_ddd || ""}
              onChange={(e) => setEnd_ddd(e.target.value)}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Telefone</label>
            <input
              type="text"
              className="div_custom_UpdateInput"
              value={end_tel || ""}
              onChange={(e) => setEnd_tel(e.target.value)}
            />
          </div>

          <div className="div_custom_UpdateItem">
            <label>Tipo Telefone</label>
            <select
              className="div_custom_Select"
              onChange={handleChangeTelEmp}
              value={tipoTelEmp}
            >
              <option value=""></option>
              <option value="MOBILE">Celular</option>
              <option value="BUSINESS">Empresa</option>
              <option value="HOME">Casa</option>
            </select>
          </div>
        </div>

        <div className="div_custom_UpdateRight">
          <Button
            variant="outlined"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={click}
          >
            Cadastrar
          </Button>
        </div>

        {criado && (
          <div className="div_custom_UpdateItem">
            <label>Admin: {urlAdminMooda + inputs.slug + "/login"}</label>
            <label>Mobile: {urlMooda + inputs.slug + "/home"}</label>
            <label>Vendedor: {urlMooda + inputs.slug + "/employee"}</label>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Company;
